import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class BigArticleFeaturette extends Component {
  static propTypes = {
    article: PropTypes.shape({}).isRequired,
  };

  state = {};

  render() {
    const { article } = this.props;
    return (
      <>
        <div className="col-sm-12 text-right">
          <Link to={`/articles/${article.id}`} href={`/articles/${article.id}`}>
            <div className="featurette my-5">
              <img
                src={article.pathThumbnailMedium}
                alt=""
                className="blog-img-lg wow slideInUp"
                data-wow-duration="2.5s"
              />

              <div className="text-container right bg-white w-25 p-5 wow slideInUp text-left">
                <h2 className="tw-text-skiptiOrange mb-4">{article.title}</h2>
                <p className="text-color4 fw-light">{article.lead}</p>
              </div>
            </div>
          </Link>
        </div>
        {/* <div className="col-12 mb-5" key={index}>
                                      <ArticleRow article={article} />
                                  </div> */}
      </>
    );
  }
}

export default BigArticleFeaturette;
